module.exports = __webpack_public_path__ + "img/services.833dae4c.jpg";